<div class="cart-item">
  <div class="d-flex justify-content-between mb-3">
    <div class="d-flex" style="align-items: center">
      <div class="quantity">{{ item?.quantity }}X</div>
      <img
        style="width: 18px; height: 18px"
        src="assets/images/tickets/ticket.png"
      />
      <div class="ticket-title" style="font-size: larger">
        {{ helpers.getElementTranslatedName(item?.ticket) }}
      </div>
    </div>
    <div class="d-flex" style="align-items: center">
      <div class="d-flex" *ngIf="router.url.includes('sport')">
        <p
          class="ticket-title px-2 mb-0"
          style="font-size: larger"
          [ngClass]="
            !item?.ticket?.needToPay && item?.ticket.price > 0
              ? 'not-need-to-pay'
              : ''
          "
        >
          <ng-container *ngIf="item?.ticket?.price !== 0">
            <span
              [innerHTML]="
                item?.ticket?.price
                  | toVat
                  | number : '1.2-2'
                  | customCurrency : 'SAR' : 'symbol' : '#555770' : 28
              "
            ></span>
          </ng-container>

          <ng-container *ngIf="item?.ticket?.price === 0">
            {{ "free" | translate }}
          </ng-container>
        </p>
        <p
          *ngIf="!item?.ticket?.needToPay && item?.ticket.price > 0"
          class="ticket-title px-2 mb-0"
          style="font-size: larger; color: red"
        >
          {{ "free" | translate }}
        </p>
      </div>

      <p
        *ngIf="!router.url.includes('sport')"
        class="ticket-title px-2 mb-0"
        style="font-size: larger"
      >
        <ng-container *ngIf="item?.ticket?.price !== 0">
          <span
            [innerHTML]="
              item?.ticket?.price
                | toVat
                | number : '1.2-2'
                | customCurrency : 'SAR' : 'symbol' : '#555770' : 28
            "
          ></span>
        </ng-container>

        <ng-container *ngIf="item?.ticket?.price === 0">
          {{ "free" | translate }}
        </ng-container>
      </p>
      <img
        *ngIf="!review"
        (click)="deleteItem()"
        class="time-icons"
        style="cursor: pointer"
        src="assets/images/tickets/trash.png"
      />
    </div>
  </div>
  <div class="d-flex gap-3" style="justify-content: space-between">
    <div class="d-flex gap-1 align-items-center">
      <img class="time-icons" src="assets/images/tickets/calendar.svg" />
      <p class="mb-0 ticket-title" style="direction: ltr">
        {{
          item?.date
            ? (item.date
              | localizedDate : "EEEE, MMM d, y" : translate.currentLang)
            : (item?.schedule?.startAt * 1000
              | localizedDate : "EEEE, MMM d, y" : translate.currentLang)
        }}
      </p>
    </div>

    <div
      *ngIf="
        (item?.ticket?.isScheduled && dateTimes?.length > 0 && review) ||
        isSport
      "
      class="d-flex align-items-center"
    >
      <img class="time-icons" src="assets/images/tickets/clock.svg" />
      <p class="mb-0 ticket-title">
        {{
          item?.time?.time ? item.time.time : helpers.convertToAMPM(item?.time)
        }}
      </p>
    </div>
  </div>

  <div
    *ngIf="item?.ticket?.isScheduled && dateTimes?.length > 0 && !review"
    class="d-flex justify-content-between mt-3 align-items-center"
  >
    <p class="mb-0 choose-ticket" style="padding-inline-start: 0">
      {{ "choose-time" | translate }}
    </p>
    <ng-select
      placeholder="{{ 'hour' | translate }}"
      virtualScroll="true"
      (change)="selectTime($event)"
      [ngModel]="item?.time?.id"
    >
      <ng-option *ngFor="let time of dateTimes" [value]="time.id">{{
        time.time
      }}</ng-option>
    </ng-select>
  </div>
  <div
    class="d-flex gap-1 mt-3 align-items-start"
    *ngIf="(!item?.ticket?.isScheduled || dateTimes?.length == 0) && !isSport"
  >
    <img
      class="time-icons"
      *ngIf="!review"
      src="assets/images/tickets/clock.svg"
    />
    <p class="mb-0 ticket-title" style="padding-inline-start: 0">
      {{ "come-anytime" | translate }}
      {{
        item?.schedule?.startAt * 1000
          | localizedDate : "hh:mm a" : translate.currentLang
      }}
      {{ "to" | translate }}
      {{
        item?.schedule?.endAt * 1000
          | localizedDate : "hh:mm a" : translate.currentLang
      }}
    </p>
  </div>
  <ng-container *ngIf="selectedSeats">
    <div
      class="d-flex gap-1 mt-3 align-items-start"
      *ngFor="let seat of getSelectedSeats()"
    >
      <p
        class="mb-0 ticket-title w-100 d-block"
        style="padding-inline-start: 0"
      >
        <svg
          style="display: inline"
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.16667 9.42887C4.60869 9.42887 5.03262 9.60447 5.34518 9.91703C5.65774 10.2296 5.83333 10.6535 5.83333 11.0955V12.7622H14.1667V11.0955C14.1667 10.6535 14.3423 10.2296 14.6548 9.91703C14.9674 9.60447 15.3913 9.42887 15.8333 9.42887M4.16667 9.42887C3.72464 9.42887 3.30072 9.60447 2.98816 9.91703C2.67559 10.2296 2.5 10.6535 2.5 11.0955V14.4289C2.5 14.8709 2.67559 15.2948 2.98816 15.6074C3.30072 15.9199 3.72464 16.0955 4.16667 16.0955H15.8333C16.2754 16.0955 16.6993 15.9199 17.0118 15.6074C17.3244 15.2948 17.5 14.8709 17.5 14.4289V11.0955C17.5 10.6535 17.3244 10.2296 17.0118 9.91703C16.6993 9.60447 16.2754 9.42887 15.8333 9.42887M4.16667 9.42887V5.26221C4.16667 4.59917 4.43006 3.96328 4.8989 3.49444C5.36774 3.0256 6.00363 2.76221 6.66667 2.76221H13.3333C13.9964 2.76221 14.6323 3.0256 15.1011 3.49444C15.5699 3.96328 15.8333 4.59917 15.8333 5.26221V9.42887M5 16.0955V17.7622M15 16.0955V17.7622"
            stroke="#727385"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        {{ "Section" | translate }}: {{ seat.Section }},
        {{ "Row" | translate }}: {{ seat.Row }}, {{ "Seat" | translate }}:
        {{ seat.Seat }}
      </p>
    </div>
  </ng-container>
</div>
